import { Toast } from "@newsela/angelou";

export const EVENT_TOAST_INVALID_TEXT_LENGTH = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Guided Highlighting responses cannot exceed 1000 characters",
};

export const GUIDED_HIGHLIGHTING_ANSWER_MAX_LENGTH = 1000;
